module.exports = __webpack_public_path__ + "img/truck-container-empty.e665e0a6.svg";